import { useState } from 'react';
import {
  InformationCircleIcon,
  MagnifyingGlassIcon,
  StarIcon,
} from '@heroicons/react/24/outline';
import { LinkIcon } from '@heroicons/react/24/solid';

export function WhiteLabelServiceContentPage() {
  const [searchQuery, setSearchQuery] = useState('');

  // Custom styles as inline CSS objects
  const styles = {
    mainContainer: {
      backgroundColor: '#f5f5f5',
      minHeight: '100vh',
      fontFamily:
        "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    },
    header: {
      backgroundColor: 'white',
      borderBottom: '1px solid #e2e8f0',
      padding: '12px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    searchContainer: {
      display: 'flex',
      alignItems: 'center',
      border: '1px solid #e2e8f0',
      borderRadius: '4px',
    },
    searchTypeSelector: {
      padding: '4px 12px',
      borderRight: '1px solid #e2e8f0',
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      fontSize: '14px',
      color: '#6b7280',
    },
    searchInput: {
      padding: '4px 8px',
      outline: 'none',
      fontSize: '14px',
      width: '256px',
    },
    searchButton: {
      backgroundColor: '#005b94',
      color: 'white',
      padding: '4px 16px',
      borderRadius: '4px',
    },
    actionButtonsContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      marginLeft: '8px',
    },
    actionButton: {
      border: '1px solid #e2e8f0',
      borderRadius: '4px',
      padding: '4px',
    },
    filterBar: {
      padding: '8px 16px',
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
    },
    filterText: {
      color: '#4b5563',
    },
    resetFiltersButton: {
      marginLeft: '8px',
      color: '#2563eb',
      cursor: 'pointer',
    },
    activeFilterTag: {
      padding: '0 16px 8px 16px',
    },
    filterTagContent: {
      display: 'inline-flex',
      alignItems: 'center',
      backgroundColor: '#e02020',
      color: 'white',
      borderRadius: '9999px',
      padding: '4px 12px',
      fontSize: '14px',
    },
    filterTagCloseButton: {
      marginLeft: '4px',
      backgroundColor: 'white',
      borderRadius: '9999px',
      width: '16px',
      height: '16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    filterTagCloseIcon: {
      color: '#e02020',
      fontWeight: 'bold',
      fontSize: '12px',
    },
    resultsCountContainer: {
      padding: '8px 16px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    resultsCount: {
      color: '#4b5563',
    },
    sortContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    sortText: {
      color: '#4b5563',
    },
    eventItemContainer: {
      padding: '8px 16px',
    },
    eventCard: {
      backgroundColor: 'white',
      borderRadius: '4px',
      boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
      padding: '16px',
    },
    eventCardHighlighted: {
      backgroundColor: 'white',
      borderRadius: '4px',
      boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
      padding: '16px',
      borderLeft: '4px solid #e02020',
    },
    eventTitle: {
      fontWeight: '500',
      fontSize: '18px',
    },
    eventContentContainer: {
      display: 'flex',
      alignItems: 'flex-start',
      marginTop: '8px',
    },
    eventIconContainer: {
      flexShrink: 0,
      marginRight: '12px',
    },
    eventIconBlue: {
      width: '32px',
      height: '32px',
      borderRadius: '9999px',
      backgroundColor: '#005b94',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    eventIconRed: {
      width: '32px',
      height: '32px',
      borderRadius: '9999px',
      backgroundColor: '#e02020',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    eventIconSvg: {
      width: '20px',
      height: '20px',
      color: 'white',
    },
    eventContent: {
      flex: 1,
    },
    eventMetadata: {
      fontSize: '12px',
      color: '#6b7280',
    },
    eventDescription: {
      fontSize: '14px',
      marginTop: '4px',
    },
    eventActions: {
      flexShrink: 0,
      marginLeft: '12px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    actionIcon: {
      width: '20px',
      height: '20px',
      color: '#9ca3af',
    },
  };

  return (
    <div style={styles.mainContainer}>
      {/* Header/Search Bar */}
      <div style={styles.header}>
        <div style={styles.searchContainer}>
          <div style={styles.searchTypeSelector}>
            <span>Standard</span>
            <svg
              style={{ width: '16px', height: '16px' }}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </div>
          <input
            type="text"
            placeholder="Suche nach..."
            style={styles.searchInput}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        <button style={styles.searchButton}>
          <MagnifyingGlassIcon style={{ width: '20px', height: '20px' }} />
        </button>

        <div style={styles.actionButtonsContainer}>
          <button style={styles.actionButton}>
            <svg
              style={{ width: '20px', height: '20px' }}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
              />
            </svg>
          </button>
          <button style={styles.actionButton}>
            <svg
              style={{ width: '20px', height: '20px' }}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
          <button style={styles.actionButton}>
            <LinkIcon style={{ width: '20px', height: '20px' }} />
          </button>
        </div>
      </div>

      {/* Filter Bar */}
      <div style={styles.filterBar}>
        <span style={styles.filterText}>Aktive Filter:</span>
        <button style={styles.resetFiltersButton}>
          ALLE FILTER ZURÜCKSETZEN
        </button>
      </div>

      {/* Active Filter Tag */}
      <div style={styles.activeFilterTag}>
        <div style={styles.filterTagContent}>
          <span>SC xxxx UP - Produktvariante</span>
          <button style={styles.filterTagCloseButton}>
            <span style={styles.filterTagCloseIcon}>×</span>
          </button>
        </div>
      </div>

      {/* Results Count and Sort */}
      <div style={styles.resultsCountContainer}>
        <span style={styles.resultsCount}>344 Ergebnisse</span>
        <div style={styles.sortContainer}>
          <svg
            style={{ width: '16px', height: '16px' }}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"
            />
          </svg>
          <span style={styles.sortText}>Relevanz</span>
          <svg
            style={{ width: '16px', height: '16px' }}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </div>
      </div>

      {/* First Item - SC xxxx UP */}
      <div style={styles.eventItemContainer}>
        <div style={styles.eventCard}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div>
              <h3 style={{ fontWeight: '500' }}>SC xxxx UP</h3>
              <p style={{ fontSize: '14px', color: '#6b7280' }}>
                Produktvariante
              </p>
            </div>
            <svg
              style={{ width: '20px', height: '20px', color: '#9ca3af' }}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
              />
            </svg>
          </div>
        </div>
      </div>

      {/* Event Items */}
      {events.map((event) => (
        <div key={event.id} style={styles.eventItemContainer}>
          <div
            style={
              event.highlighted ? styles.eventCardHighlighted : styles.eventCard
            }
          >
            <h3 style={styles.eventTitle}>{event.title}</h3>
            <div style={styles.eventContentContainer}>
              <div style={styles.eventIconContainer}>
                <div
                  style={
                    event.highlighted
                      ? styles.eventIconRed
                      : styles.eventIconBlue
                  }
                >
                  <svg
                    style={styles.eventIconSvg}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
              </div>
              <div style={styles.eventContent}>
                <p style={styles.eventMetadata}>
                  {event.date} · Deutsch · Ereignisse_LS_Service-xx-ID ·
                  Gesamtes Produkt · Sunny Central Storage 3600 UP-XT (SCS 3600
                  UP-XT) · Sunny Central Storage 3430 UP-XT (SCS 3430 UP-XT) ·
                  Sunny Central Storage 2400 UP-XT
                </p>
                <p style={styles.eventDescription}>{event.description}</p>
              </div>
              <div style={styles.eventActions}>
                <button>
                  <StarIcon style={styles.actionIcon} />
                </button>
                <button>
                  <InformationCircleIcon style={styles.actionIcon} />
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

const events = [
  {
    id: '7901',
    title: 'Ereignis 7901',
    date: '15.05.2020',
    highlighted: true,
    description:
      'Ereignis 7901 Erläuterung: Interner Stackfehler. Verhalten des Wechselrichters: Störungsstufe 1.30 s Störungsstufe 2.1 min Abhilfe: PV-Anlage neu starten ( Computer )',
  },
  {
    id: '7620',
    title: 'Ereignis 7620',
    date: '15.05.2020',
    highlighted: true,
    description:
      'Ereignis 7620 Erläuterung: Interner Kommunikationsfehler ist aufgetreten oder Kommunikation ist unterbrochen. Verhalten des Wechselrichters: Störungsstufe 2.',
  },
  {
    id: '7601',
    title: 'Ereignis 7601',
    date: '15.05.2020',
    highlighted: true,
    description:
      'Ereignis 7601 Erläuterung: Interner Kommunikationsfehler ist aufgetreten oder Kommunikation ist unterbrochen. Verhalten des Wechselrichters: Störungsstufe 1.30 s Störungsstufe 2.',
  },
  {
    id: 'neu',
    title: 'SC neu [Service]',
    date: '15.05.2020',
    highlighted: false,
    description:
      'Ereignis 3205 Ereignis 3803 Ereignis 3301 Ereignis 3401 Ereignis 3502 Ereignis 3601 Ereignis 3617 Ereignis 3621',
  },
  {
    id: '6512',
    title: 'Ereignis 6512',
    date: '15.05.2020',
    highlighted: true,
    description:
      'Ereignis 6512 Erläuterung: Ansaugtemperatur ist zu niedrig. Verhalten des Wechselrichters: Störungsstufe 1.30 s Störungsstufe 2.5 s Abhilfe: Umgebungstemperatur prüfen.',
  },
  {
    id: '6516',
    title: 'Ereignis 6516',
    date: '15.05.2020',
    highlighted: true,
    description:
      'Ereignis 6516 Erläuterung: Übertemperatur Sinusfilter/Netzfilter (Warngrenze überschritten) Abhilfe: Sinuswellen-Filterdrossel prüfen. Umgebungstemperatur prüfen. Signalfilter prüfen.',
  },
  {
    id: '3501',
    title: 'Ereignis 3501',
    date: '15.05.2020',
    highlighted: true,
    description:
      'Ereignis 3501 Erläuterung: Fehler: Das Isolationsüberwachungsgerät hat einen zu geringen Erdungswiderstand gemessen. Verhalten des Wechselrichters: Störungsstufe 1.30 min Störungsstufe.',
  },
  {
    id: '7512',
    title: 'Ereignis 7512',
    date: '15.05.2020',
    highlighted: true,
    description:
      'Ereignis 7512 Erläuterung: Abhilfe: Ein Neustart des Wechselrichters ist aufgetreten.',
  },
  {
    id: '6515',
    title: 'Ereignis 6515',
    date: '15.05.2020',
    highlighted: true,
    description:
      'Ereignis 6515 Erläuterung: Temperatur im Innenraum des Wechselrichters ist zu hoch. Verhalten des Wechselrichters: Störungsstufe 1.30 s Störungsstufe 2.',
  },
  {
    id: '7909',
    title: 'Ereignis 7909',
    date: '15.05.2020',
    highlighted: true,
    description:
      'Ereignis 7909 Erläuterung: Interner Stackfehler: Hardware-Defekt in IGBT-Modul oder Sonstige: Kundenstation: Softwarefehler. Wird mit Release 101 behoben. Update mindestens auf.',
  },
];
